import React, { useEffect, useMemo } from 'react';

import useAuth from './hooks/useAuth';
import useError from './hooks/useError';
import { isMobile } from './utils/util';
import { redirect, errorRedirect } from './utils/network';

import FrameLayout from './layouts/FrameLayout';
import AuthPage from './pages/AuthPage';
import ErrorPage from './pages/ErrorPage';

import './styles/main.scss';

/**
 * @description Application
 */
function App() {
  // Auth Redux 사용
  const { auth, startPolling } = useAuth();
  // Error Redux 사용
  const { error, onErrorInit } = useError();
  // 현재 유저 환경이 모바일인지 여부
  const mobile = useMemo(() => isMobile(), []);

  // 에러가 없으면 자동으로 폴링을 시작합니다.
  useEffect(() => {
    if (error.type === 0 && auth.polling_uri) startPolling();
  }, []);

  // 폴링이 성공하거나 실패하면 리다이렉션 시킵니다.
  useEffect(() => {
    if (auth.polling_result === true)
      redirect(auth.redirect_uri, auth.code, auth.state);
    if (auth.polling_result === false)
      errorRedirect(
        auth.redirect_uri,
        auth.state,
        auth.polling_data?.error,
        auth.polling_data?.message,
      );
  }, [auth.polling_result]);

  // 화면을 보여줍니다.
  const view = useMemo(() => {
    const noErr = error.type === 0;

    // 서버로 받아온 데이터가 잘못되었을 경우
    if (noErr && !auth.code) {
      onErrorInit({ type: 2 });
      return null;
    }

    return noErr ? <AuthPage /> : <ErrorPage />;
  }, [auth.code, error.type, mobile, onErrorInit]);

  return (
    <div className="application">
      <FrameLayout mobile={mobile}>{view}</FrameLayout>
    </div>
  );
}

export default App;
